import { API_BASE } from '../../config/api';

async function parseJson(response) {
    const text = await response.text();
    if (!text) return {};
    try {
        return JSON.parse(text);
    } catch (_error) {
        return { raw: text };
    }
}

export async function getDashboardData(selectedTable, { forceRefresh = false, timeWindowHours = 12, trendMode = 'per_range', originWindowHours = 3 } = {}) {
    const params = new URLSearchParams();
    if (forceRefresh) params.append('refresh', 'true');
    if (timeWindowHours) params.append('hours', String(timeWindowHours));
    if (trendMode) params.append('mode', String(trendMode));
    if (originWindowHours) params.append('origin_hours', String(originWindowHours));

    const response = await fetch(`${API_BASE}/dashboard-data/${selectedTable}?${params.toString()}`);
    const result = await parseJson(response);
    if (!response.ok || result.success === false) {
        throw new Error(result.error || `HTTP ${response.status}`);
    }
    return result;
}
